export default {
  name: 'quick-nav',
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '快捷导航',
          icon: 'el-icon-position',
          content: {
            list: [{
              label: '批量下单',
              img: 'bi-journal-arrow-down',
              link: {}
            }, {
              label: '按型号下单',
              img: 'bi-boxes',
              link: {}
            }, {
              label: '收藏清单',
              img: 'bi-card-checklist',
              link: {}
            }, {
              label: '客户中心',
              img: 'bi-person',
              link: {}
            }]
          },
          config: [{
            label: '导航数据',
            name: 'list',
            type: 'mapList',
            attrs: {
              name: {
                label: '标题',
                value: 'label'
              },
              img: {
                label: '图标',
                value: 'img'
              },
              link: {
                label: '跳转链接',
                value: 'link'
              }
            }
          }]
        };
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {}
};